///<amd-module name="typeahead/core/logging/TypeaheadMetric" />

import {abTest} from "typeahead/core/plugins/ExecutionHelper";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class TypeaheadMetric {

    public contentFlavor: string;
    public deviceType: string;
    public guid: string;
    public lob: string;
    public locale: string;
    public pageId: string;
    public pointOfSale: string;
    public siteId: string;
    public textInputElementId: string;
    public timestamp: number;
    public type: string;
    public userAgent: string;
    public variants: string;

    constructor(lob: string, elementId: string, type: string, activeESSTests: string) {
        this.contentFlavor = "uTA";
        this.deviceType = TypeaheadUtils.getDeviceType();
        this.guid = TypeaheadUtils.getGuid();
        this.lob = lob;
        this.locale = TypeaheadUtils.getLocale();
        this.pageId = TypeaheadUtils.getPageId();
        this.pointOfSale = TypeaheadUtils.getPointOfSale();
        this.siteId = TypeaheadUtils.getSiteId();
        this.textInputElementId = elementId;
        this.timestamp = Date.now();
        this.type = type;
        this.userAgent = navigator.userAgent;
        this.variants = _.compact([abTest.getActiveClientTests(), activeESSTests]).join("|");
    }
}
